export const formatPhoneNumberFromE164 = (phoneNumber: string) => {
    const regex = /^\+[1-9]\d{1,14}$/;
    if (!regex.test(phoneNumber)) {
        throw new Error("Invalid E.164 phone number");
    }
    return `(${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(
        5,
        8
    )}-${phoneNumber.slice(8)}`;
};
